import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GeoLocation } from '@wilson/interfaces';
import { Observable, of, shareReplay, switchMap, take } from 'rxjs';
import { GetLocationAction } from './state/location.actions';
import { LocationState } from './state/location.state';

@Injectable({
  providedIn: 'root',
})
export class LocationsStoreService {
  private store = inject(Store);

  private ongoingRequests: Map<string, Observable<GeoLocation>> = new Map();

  getLocationFromCache(
    id: string | null,
  ): Observable<GeoLocation | null | undefined> {
    if (id) {
      const location$ = this.store.select(LocationState.location(id)).pipe(
        take(1),
        switchMap((location) => {
          if (location) {
            return of(location);
          } else {
            const ongoingRequest = this.ongoingRequests.get(id);
            if (ongoingRequest) {
              return ongoingRequest;
            } else {
              const newRequest$ = this.store
                .dispatch(new GetLocationAction(id))
                .pipe(
                  switchMap(() =>
                    this.store.select(LocationState.location(id)),
                  ),
                  take(1),
                  shareReplay(1),
                );
              this.ongoingRequests.set(id, newRequest$);
              return newRequest$;
            }
          }
        }),
        shareReplay(1),
      );
      return location$;
    } else {
      return of(null);
    }
  }
}
